<template>
  <div
    class="slider"
    :class="`slider--${type}`"
    @mouseover="updateMouseCursor('slider')"
    @mouseout="updateMouseCursor('default')">
    <div
      v-slider-swipe="{ left: $_swipeLeft, right: $_swipeRight }"
      v-slider="{ onClick: $_onElementClick }"
      ref="elements"
      class="slider__wrapper">

      <slot />
    </div>

    <div class="slider__counter">{{ currentSlide + 1 }} / {{ elementsCount }}</div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapMutations } from 'vuex'
import Hammer from 'hammerjs'

export default {
  data: () => ({
    ended: false,
    currentSlide: 0,
    elementsCount: 0,
    swiping: false
  }),
  props: {
    type: {
      type: String,
      default: 'default'
    }
  },
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor',
      'updateMouseCursorPayload'
    ]),
    $_onElementClick (element, elementsCount, index, scroll = true) {
      if (this.swiping) return
      this.$_scrollTo(element, elementsCount, index, scroll)
    },
    $_scrollTo (element, elementsCount, index, scroll = true) {
      this.currentSlide = index
      this.elementsCount = elementsCount
      this.updateMouseCursorPayload([index + 1, '/', elementsCount])

      if (!scroll) return
      const parentNode = element.parentNode
      parentNode.scrollTo({
        top: 0,
        left: element.offsetLeft - (parentNode.offsetWidth / 2 - element.offsetWidth / 2),
        behavior: 'smooth'
      })
    },
    $_swipeLeft (event) {
      this.swiping = true
      window.requestAnimationFrame(() => { this.swiping = false })
      const elements = Array.prototype.slice.call(this.$refs.elements.children)
      const currentElement = elements[this.currentSlide + 1]
      if (typeof currentElement !== 'undefined') this.$_scrollTo(currentElement, elements.length, this.currentSlide + 1)
    },
    $_swipeRight (event) {
      this.swiping = true
      window.requestAnimationFrame(() => { this.swiping = false })
      const elements = Array.prototype.slice.call(this.$refs.elements.children)
      const currentElement = elements[this.currentSlide - 1]
      if (typeof currentElement !== 'undefined') this.$_scrollTo(currentElement, elements.length, this.currentSlide - 1)
    }
  },
  directives: {
    slider: {
      bind (el, binding) {
        const elements = Array.prototype.slice.call(el.children)
        _.forEach(elements, (element, key) => { element.addEventListener('click', binding.value.onClick.bind(undefined, element, elements.length, key)) })
        binding.value.onClick(elements[0], elements.length, 0, false)
      },
      unbind (el, binding) {
        const elements = Array.prototype.slice.call(el.children)
        _.forEach(elements, (element, key) => { element.removeEventListener('click', binding.value.onClick.bind(undefined, element, elements.length, key)) })
      }
    },
    'slider-swipe': {
      bind (el, binding) {
        const manager = new Hammer.Manager(el)
        const swipe = new Hammer.Swipe()
        manager.add(swipe)
        manager.on('swipeleft', binding.value.left)
        manager.on('swiperight', binding.value.right)
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/breakpoint.scss';

.slider {
  position: relative;
}

.slider__wrapper {
  white-space: nowrap;
  position: relative;
  overflow-x: scroll;
  box-sizing: border-box;
  overflow: hidden;
}

.slider__wrapper > * {
  display: inline-block;
  width: 100%;
  margin: 0;

  &:first-child {
    @include media(">=large") {
      margin-left: 20%;
    }
  }

  @include media(">=large") {
    width: 60%;
    padding: 3%;
    box-sizing: border-box;
  }
}

.slider__counter {
  text-align: center;
  font-size: 1.8rem;
  margin-top: 2rem;
  @include media(">=large"){
    display: none;
  }
}
</style>
